// ProgramCustomEmail.js
import React, { useState } from 'react';
import './ProgramCustomEmail.css';
import { sendCustomEmailForProgram } from '../../api/programs';
import notifications from '../../notifications';

const ProgramCustomEmail = ({ programId, handleClose }) => {
  const [formData, setFormData] = useState({
    subject: '',
    body1: '',
    body2: '',
    body3: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await sendCustomEmailForProgram(programId, formData)
    if (!!response.data) {
      notifications.notifySuccess('Email sent successfully')
      handleClose()
    } else {
      notifications.notifyError('Failed to send email')
    }
  };

  return (
    <form className="coach-form" onSubmit={handleSubmit}>
      <label>
        Subject:
        <input
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
        />
      </label>

      <label>
        Body 1:
        <textarea
          name="body1"
          value={formData.body1}
          onChange={handleChange}
        />
      </label>

      <label>
        Body 2:
        <textarea
          name="body2"
          value={formData.body2}
          onChange={handleChange}
        />
      </label>

      <label>
        Body 3:
        <textarea
          name="body3"
          value={formData.body3}
          onChange={handleChange}
        />
      </label>

      <button type="submit">Submit</button>
    </form>
  );
};

export default ProgramCustomEmail;